/**
 * Article comment mutations (Supabase Edge, same anon pattern as submit).
 * Single `comment-edit` function; body includes `actionType`: like | edit | delete.
 */
const BASE =
  import.meta.env.VITE_SUPABASE_FUNCTIONS_BASE ?? 'https://sbknwbswqkneppxbkxto.supabase.co/functions/v1';


export const ARTICLE_COMMENT_ACTION_URL = `${BASE}/comment-edit`;